import {SORT_FIELD_SEO} from './constants'

import type {SortField} from './types'

/**
 * The SEO sort is applied server-side on SEO SRPs and is never a user choice,
 * so anything user-facing treats it as "no sort selected".
 */
export const omitSeoSortField = (
  sortField: SortField | undefined
): SortField | undefined =>
  sortField === SORT_FIELD_SEO ? undefined : sortField
